import CoinDefinition from './coin-definition'
import Denomination from './denomination'
import coinDefinitions from './coin-definitions'

class CoinFactory {
  #definitionByDenomination = new Map<Denomination, CoinDefinition>()

  constructor() {
    coinDefinitions.forEach(definition => {
      this.#definitionByDenomination.set(definition.denomination, definition)
    })
  }

  getCoinDefinition(d: Denomination) {
    return this.#definitionByDenomination.get(d) as CoinDefinition
  }
}

export default new CoinFactory()
